import { Reducer } from "redux";

import { SaveNotesResponse } from "../models/Api/Notes";
import { UpdateNotesDispatchTypes } from "../models/DispatchTypes/Notes";
import { UpdateAdminNotesActionDispatchTypes } from "../constants/Notes";

export const initialState: SaveNotesResponse = {
  loading: false,
  response: {
    templateVersionId: -1,
    noteTemplateId: -1,
    version: -1,
    templateJson: "",
    approvalStatusId: -1,
    approvalStatusName: "",
    templateCategoryId: -1,
    templateCategoryName: "",
    templateName: "",
    dateCreated: "",
    userCreated: "",
    showInHpPortal:false,
  },
  error: null,
};

const UpdateNotesReducer: Reducer<
  SaveNotesResponse,
  UpdateNotesDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case UpdateAdminNotesActionDispatchTypes.UPDATE_NOTES_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case UpdateAdminNotesActionDispatchTypes.UPDATE_NOTES_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case UpdateAdminNotesActionDispatchTypes.UPDATE_NOTES_ERROR: {
      return {
        ...state,
        error: action.error,
        response: initialState.response,
        loading: false,
      };
    }
    case UpdateAdminNotesActionDispatchTypes.UPDATE_NOTES_RESET: {
      return initialState;
    }
  }
  return state;
};

export default UpdateNotesReducer;
